import type IsoDate from '../../../models/IsoDate';
import { requestAndParse, requestSuccessful } from '../request';

const editStudyParticipant = async (
    participantId: string,
    startDate: IsoDate,
    endDate: IsoDate,
) => {
    const route = 'admin/edit-study-participant';
    const payload = {
        participantId,
        startDate,
        endDate,
    };
    const response = await requestAndParse(route, payload, 'POST');

    const success = requestSuccessful(response);
    const message = response.body?.message as string | undefined;

    return { success, message };
};

export default editStudyParticipant;
